var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAccountGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_2467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7907 41C52.3953 41.0001 57 54.1912 57 61H29.7907H3C3 54.1912 7.18605 40.9999 29.7907 41Z",
    fill: "#D8C041"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 22.5,
    r: 12.5,
    fill: "#D8C041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_2467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccountGold);
export default __webpack_public_path__ + "static/media/User_Account_Gold.ae4dc1c0924cdc47187c3a097e5f56f2.svg";
export { ForwardRef as ReactComponent };